<template>
    <div class="person">
        <div class="condition">
            <!-- <div class="item">
                <div class="label">月份:</div>
                <el-date-picker
                v-model="conditionData.dataTime"
                type="month"
                size="small" 
                value-format="yyyy-MM-dd"
                placeholder="选择月">
                </el-date-picker>
            </div> -->
            <div class="item">
                <div class="label">险种类型:</div>
                <el-select v-model="conditionData.cProdType" size="small" placeholder="请选择"  class="citem-input" @change="changeCompany">
                    <el-option
                    v-for="item in insuranceList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>
        <div class="table">
            <div class="handle" style="width:99%">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <el-button type="success" size="small" icon="el-icon-download" @click="downloadExcel">导出数据</el-button>
            </div>
            <div class="title">
                意健险案件数据月报表（未决分析）
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="600px"
                :style="'width:'+ width"
                v-if="isShow"
                >
                
                <el-table-column
                prop="mechanismName"
                label="机构/月份"
                align="center"
                width="180"
                fixed="left"
                >
                </el-table-column>
                <el-table-column label="1月" align="center">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[0].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[0].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[0].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="2月" align="center">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[1].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[1].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[1].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="3月" align="center">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[2].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[2].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[2].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="4月" align="center">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[3].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[3].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[3].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="5月" align="center">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[4].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[4].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[4].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="6月" align="center">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[5].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[5].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[5].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="7月" align="center">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[6].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[6].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[6].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="8月" align="center">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[7].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[7].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[7].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="9月" align="center">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[8].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[8].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[8].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="10月" align="center">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[9].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[9].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[9].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="11月" align="center">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[10].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[10].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[10].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="12月" align="center">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[11].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[11].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[11].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>


                    
                <el-table-column label="全年" width="300" align="center" fixed="right">
                    <el-table-column
                    prop=""
                    label="已完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[12].complete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="未完成"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[12].notcomplete}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop=""
                    label="合计"
                    align="center"
                    width="100"
                    >
                    <template slot-scope="scope">
                        {{scope.row.dataCensusMonth[12].heji}}
                    </template>
                    </el-table-column>
                </el-table-column>
                
            </el-table>

        </div>


        
       
    </div>
</template>
<script>
import api from '../../../api/main'
import { insuranceList} from "../../../assets/selectList/anxin";
import { parseTimeNowMM } from '../../../utils/index'
export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            insuranceList:insuranceList,
            title:'',
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            conditionData:{
                dataTime:null,
                cProdType:'',
                operatorMechanismId:localStorage.getItem('mechanismid'),
                page:1,
                pageSize:10,
            },
            tableData:[{}],
            isShow:true,
            width:'100%',
        }
    },
    created(){
        

    },
    mounted(){
        this.conditionData.dataTime = parseTimeNowMM()
        this.loadingData();
    },
    methods:{
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let option = {
                cProdType:this.conditionData.cProdType,
                page:this.conditionData.page,
                pageSize:this.conditionData.pageSize,
            };
            
            if(this.conditionData.dataTime){
                option.dataTime = this.conditionData.dataTime
            }
            let res  = await api.queryDataCensusMonth(option);
            console.log(res);
            this.tableData = res.data.data;
            // this.isShow = false;
            // this.$forceUpdate();
            // this.isShow = true;
            this.width = '99%';
            // this.width = '100%';
           
        },

        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                dataTime:null,
                cProdType:'',
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        
        async downloadExcel(){
            let res = await api.exportInventory({
                "type": 6,
                "Condition":this.conditionData
            },'意健险案件数据月报表');
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 10px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .title{
            width: 100%;
            text-align: center;
            margin-bottom: 10px;
            font-size: 18px;
            letter-spacing: 2px;
            font-weight: bold;
        }
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            .label{
                margin-bottom: 5px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
